module.exports = __webpack_public_path__ + "img/pdfLogo.8f9dac1b.png";